/**
 * CG-4 — guardian nav config (design N1).
 *
 * The reduced 3-item nav for guardian-only accounts: Home · Approvals ·
 * Settings. The athlete's five tabs (Today / Train / Races / Team) mean
 * nothing to a guardian, and the "Ask a coach" action is dropped too —
 * consumers pass `variant="guardian"` to SideNav alongside these items.
 * Same reduced set at every tier (BottomTab builds its own glyph rows
 * from the same routes).
 */

export interface GuardianNavItem {
  id: string;
  label: string;
  href: string;
  active?: boolean;
  badge?: number;
}

/** Build the guardian SideNav item list with the given item active and an
 *  optional pending-approvals badge on the Approvals item. */
export function guardianNavItems(
  activeId: 'guardian-home' | 'approvals' | 'settings',
  pendingCount = 0,
): GuardianNavItem[] {
  return [
    { id: 'guardian-home', label: 'Home', href: '/guardian' },
    {
      id: 'approvals',
      label: 'Approvals',
      href: '/approvals',
      ...(pendingCount > 0 ? { badge: pendingCount } : {}),
    },
    { id: 'settings', label: 'Settings', href: '/settings' },
  ].map((item) => (item.id === activeId ? { ...item, active: true } : item));
}
